import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import InfoIcon from 'assets/info-icon-lusini.svg'
import { Props } from './types'

export default function InfoBox(props: Props) {
  return (
    <Wrapper className="InfoBox" data-cy-state={props['data-cy-state']}>
      <div className="svg-wrapper">
        <InfoIcon />
      </div>
      <div className="text-wrapper">
        <div className="description_title">
          <h4>{props.title}</h4>
        </div>

        <div className="description">{props.children}</div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${theme.colors.accent.info};
  border: 1px solid ${theme.colors.accent.blue};
  padding: ${theme.spacing('s')};
  display: flex;
  align-items: start;

  > .svg-wrapper {
    align-items: center;
    display: flex;
    > svg {
      height: 1.5rem;
      width: 1.5rem;
      margin-right: ${theme.spacing('xxs')};
      margin-top: -0.25rem;
      @media (min-width: ${theme.ms.SM}px) {
        margin-top: 0;
      }
    }
  }
  > .text-wrapper {
    > .description_title {
      display: flex;
      align-items: center;
      height: 1.5rem;
    }

    > .description {
      height: 100%;
      align-items: center;
      display: flex;
      ${theme.ty('r-s', null, 'r-base')}
      > span {
        ${theme.ty('r-s', null, 'r-base')}
        display: flex;
        flex-direction: row;
      }
    }
  }
`
